module.exports = __webpack_public_path__ + "static/media/whiteLogo.53dbea7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/User/Profile/whiteLogo.png
// module id = 163
// module chunks = 0